import { render, staticRenderFns } from "./EventManagementWrapper.vue?vue&type=template&id=50f24462"
import script from "./EventManagementWrapper.vue?vue&type=script&lang=js"
export * from "./EventManagementWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('50f24462')) {
      api.createRecord('50f24462', component.options)
    } else {
      api.reload('50f24462', component.options)
    }
    module.hot.accept("./EventManagementWrapper.vue?vue&type=template&id=50f24462", function () {
      api.rerender('50f24462', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/operations/EventManagementWrapper.vue"
export default component.exports